import React from 'react';
import PropTypes from 'prop-types';
import assetify from '@quintype/framework/assetify';
import { connect } from 'react-redux';
import crossIcon from '../../../../assets/icons/cross.svg';
import { postCall } from '../../../helpers/auth-client';
import Loader from '../../atoms/icons/loader';
import MoengageHelper from '../../../helpers/moengage-helper';
import Voucherify from '../../../helpers/voucherify-helper';
import { trackUserInteraction } from '../../../helpers/datalayer-utils';
import './micro-payment.m.css';

// todo: convert this component into `Controlled Component`
class UpdateMobileNumber extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      error: true,
      message: '',
      phone: '',
    };
    this.validateNumber = this.validateNumber.bind(this);
    this.update = this.update.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.updatePhoneNumberOnZoho = this.updatePhoneNumberOnZoho.bind(this);
  }

  validateNumber() {
    const { validity } = this.mobileNumber;
    if (validity.valueMissing || validity.patternMismatch) {
      this.setState({
        error: true,
        message: 'Please enter a valid 10 digit mobile number.',
      });
    }

    if (validity.valid) {
      this.setState({
        error: false,
        message: '',
        phone: this.mobileNumber.value,
      });
    }
  }

  updatePhoneNumberOnZoho() {}

  update() {
    trackUserInteraction({
      event: 'CustomEvent',
      category: 'subscription via ppa',
      action: 'click',
      label: 'change number',
    });

    this.validateNumber();
    global.Moengage &&
      MoengageHelper.walletLinkedStatusAttribute({ status: 'not-linked', name: null });
    if (!this.state.error) {
      this.setState({ isLoading: true });
      postCall('/api/member/metadata', {
        metadata: { 'phone-number': this.state.phone },
      })
        .res(() => {
          if (this.props.newSubscriptionFlow) {
            Voucherify.updateCustomer({ phone: this.state.phone });
          }
          this.updatePhoneNumberOnZoho();

          this.props.reloadMember().then(
            ({ member }) =>
              global.AccessType &&
              global.AccessType.resetWallets()
                .then(() => {
                  if (member && global.Moengage) {
                    MoengageHelper.addUser(member);
                  }
                  this.props.updateNumber();
                })
                .catch(() =>
                  this.setState({
                    error: true,
                    isLoading: false,
                    message: 'Oops Something Went Wrong!',
                  })
                )
          );
        })
        .catch(() =>
          this.setState({
            error: true,
            isLoading: false,
            message: 'Oops Something Went Wrong!',
          })
        );
    }
  }

  handleKeyPress(e) {
    const { value } = this.mobileNumber;
    if (value.length >= 10) {
      this.validateNumber();
    }

    if (e.key === 'Enter') {
      this.update();
    }
  }

  render() {
    return (
      <div styleName="story-subscribe-wrap" id="story_subscribe_wrap">
        <div styleName="story-subscribe">
          {this.props.UpdateMobileNumber === 'Update' && (
            <img styleName="" src={assetify(crossIcon)} onClick={this.props.payRead} alt="Close" />
          )}
          <div styleName="align">
            <h3 styleName="subscribe-headline">
              {this.props.UpdateMobileNumber} your Phone Number
            </h3>
            <p styleName="subscribe-summary">
              {this.props.UpdateMobileNumber === 'Update'
                ? 'Enter your phone number that can be verified with a text message.'
                : 'To proceed with this payment method, please update your phone number.'}
            </p>
            <div styleName="subscribe-buttons update-mobile-input-group">
              <input
                type="tel"
                required
                maxLength="10"
                pattern="^\d{10}$"
                placeholder={
                  this.props.UpdateMobileNumber === 'Update'
                    ? 'Enter New Phone Number'
                    : 'Enter Your Phone Number'
                }
                ref={(node) => {
                  this.mobileNumber = node;
                }}
                onKeyUp={this.handleKeyPress}
              />
              <button
                disabled={this.state.isLoading}
                onClick={this.update}
                styleName="paywall-button update-btn"
              >
                {this.state.isLoading ? <Loader /> : this.props.UpdateMobileNumber}
              </button>
              {this.state.error && <span styleName="error">{this.state.message}</span>}
            </div>
            {this.props.mobileNumber && (
              <span styleName="paywall-footer paywall-footer-mobile">
                {this.props.mobileNumber}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

UpdateMobileNumber.propTypes = {
  memberId: PropTypes.number,
  updateNumber: PropTypes.func.isRequired,
  reloadMember: PropTypes.func.isRequired,
  UpdateMobileNumber: PropTypes.string.isRequired,
  mobileNumber: PropTypes.string,
  payRead: PropTypes.func,
  newSubscriptionFlow: PropTypes.bool,
};

UpdateMobileNumber.defaultProps = {
  mobileNumber: '',
  newSubscriptionFlow: false,
};

const mapStateToProps = (state) => {
  const featureConfig = state.qt.config.features;
  return {
    newSubscriptionFlow: featureConfig.subscription.voucherify_subscription_flow,
  };
};

export default connect(mapStateToProps, {})(UpdateMobileNumber);
